<template>
  <div>
    <div class="mb-3" style="display: flex; flex-direction: row; align-items: center">
      <div style="display: flex; align-items: center; cursor: pointer" @click="$router.go(-1)">
        <i class="fa fa-angle-left fa-2x mr-3 mt-2"></i>
        <span
          class="mt-1"
          style="font-size: 16px; font-family: DM Sans, sans-serif; font-weight: 700; color: #6c6c6c"
        >
          Back
        </span>
      </div>
      <div class="mr-1 ml-1 mt-2">
        <i class="fa fa-minus fa-lg" style="transform: rotate(90deg)"></i>
      </div>
      <div style="display: flex; font-size: 16px; align-items: center; justify-content: center">
        <span class="mt-1" style="font-weight: bold; font-family: 'DM Sans', sans-serif; color: #4b4b4b">
          Counterfeit Location
        </span>
      </div>
      <div class="spacer"></div>
      <div class="ml-5 dateData text-label">
        Total Scanned
        <b class="text-value">{{ legendData ? legendData.total_scan : "-" }}</b>
      </div>

      <div class="ml-5 dateData text-label">
        Detected Counterfeit
        <b class="text-value">{{ legendData ? legendData.total_countefeit : "-" }}</b>
      </div>

      <div class="ml-5 dateData text-label">
        Date
        <b class="text-value">
          {{
            legendData
              ? `${moment(legendData.start).format("DD/MM/Y")} - ${moment(legendData.end).format(
                  "DD/MM/Y"
                )}`
              : "-"
          }}
        </b>
      </div>
    </div>
    <GmapMap
      :center="{ lat: -2.548926, lng: 118.0148634 }"
      :zoom="zoom"
      map-type-id="terrain"
      :options="{ mapTypeControl: false, streetViewControl: false }"
      style="width: 100%; min-height: 500px"
      ref="myMapRef"
      @tilesloaded="onMapReady"
    >
      <!-- <GmapCluster>
                
            </GmapCluster> -->
      <gmap-marker
        v-for="(m, index) in marker"
        :position="m.lat ? m : { lat: 0.0, lng: 0.0 }"
        :clickable="true"
        :draggable="true"
        :key="index"
        @mouseover="showInfoWindow(m)"
        @mouseout="hideInfoWindow"
      ></gmap-marker>

      <GmapInfoWindow
        :options="{
          content: hoveredMarker ? hoveredMarker.content : '',
          pixelOffset: { height: -35 },
        }"
        :position="hoveredMarker ? { lat: hoveredMarker.lat, lng: hoveredMarker.lng } : null"
        :opened="hoveredMarker !== null"
        class="custom-info-window"
      >
        {{ hoveredMarker }}
      </GmapInfoWindow>
    </GmapMap>
  </div>
</template>

<script>
import moment from "moment";
import GmapCluster from "vue2-google-maps/dist/components/cluster"; // replace src with dist if you have Babel issues
import qs from "qs";

export default {
  metaInfo: {
    title: "Counterfeit Location",
  },
  props: ["coordinates", "fields", "urlAPI", "latVar", "lngVar"],
  components: {
    GmapCluster,
  },
  data() {
    return {
      moment,
      zoom: 4,
      center: null,
      marker: null,
      customText: "",
      control: null,
      legendData: null,
      hoveredMarker: null,
    };
  },
  mounted() {
    // setTimeout(this.loadAPI(), 500000);
    let vm = this;
    vm.loadAPI();

    //The FU(🖕) function for the product team
    // setTimeout(function () {
    //     vm.loadAPI()
    // }, this.randomInt(1000,3000));
  },
  watch: {
    customText(newValue) {
      this.updateControl();
    },
  },

  methods: {
    onMapReady() {
      this.$refs.myMapRef.$mapPromise.then((map) => {
        // map.data.addGeoJson(indonesiaGeoJson);
        var styles = [
          {
            featureType: "all",
            elementType: "all",
            stylers: [{ visibility: "on" }],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ visibility: "on" }, { color: "#EEEEEE" }],
          },
          {
            featureType: "land",
            elementType: "geometry.fill",
            stylers: [{ visibility: "on" }, { color: "#EEEEEE" }],
          },
          {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [{ visibility: "on" }, { color: "#CAD2D3" }],
          },
        ];

        var styledMap = new google.maps.StyledMapType(styles, {
          name: "Custom Style",
        });
        map.mapTypes.set("custom_style", styledMap);
        map.setMapTypeId("custom_style");

        // const infoWindow = new google.maps.InfoWindow();

        // Mouseout event listener to close the info window
        // map.data.addListener('mouseout', (event) => {
        //     infoWindow.close();
        // });
        // const legend = this.$refs.mapLegend;
        // map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(legend);
      });
    },
    addCustomControl(map) {
      this.control = new CustomControl({ text: this.customText }).addTo(map);
    },
    updateControl() {
      if (this.control) {
        this.control.getContainer().innerHTML = this.customText;
      }
    },

    loadAPI() {
      let latVar = this.latVar ? this.latVar : "lat";
      let lngVar = this.lngVar ? this.lngVar : "lng";
      // console.log(this.$route.query)

      this.$http
        .get("/dashboard/counterfeit-found-detail?" + qs.stringify(this.$route.query))
        .then((resp) => {
          let coordinates = resp.data.data.detail;
          // console.log(coordinates)
          this.marker = coordinates.map(function (x) {
            return {
              ...x,
              content: `
                            <div style="font-family: 'DM Sans', sans-serif; font-weight: 600; font-style: normal; font-size: 12px; color: #393939; margin-bottom: 4px;">${x.name}</div>
                            <div style="font-family: 'DM Sans', sans-serif; font-weight: 400; font-style: normal; font-size: 10px; color: #3E3E3E; margin-bottom: 4px;">Serial Number ${
                              x.serial_number ? x.serial_number : "(Not Found)"
                            }</div>
                            <div style="font-family: 'DM Sans', sans-serif; font-weight: 400; font-style: normal; font-size: 10px; color: #AAAAAA;">${moment(x.created_at).format("DD MMMM Y | HH:mm")}</div>
                        `,
            };
          });
          // console.log(this.marker)

          // this.marker = this.marker.map

          this.legendData = resp.data.data.legend;
          // console.log(this.marker)
          // let lat = coordinates[0] && coordinates[0][latVar] ? coordinates[0][latVar] : -6.14292183
          // let lng = coordinates[0] && coordinates[0][lngVar] ? coordinates[0][lngVar] : 106.85673778
          // this.center = [lat , lng]

          // this.customText = 'Location Permission Denied Scan : ' + coordinates.length
        });
    },

    showInfoWindow(marker) {
      this.hoveredMarker = marker;
    },

    hideInfoWindow() {
      // Add a delay before hiding the info window
      setTimeout(() => {
        this.hoveredMarker = null;
      }, 200); // Adjust the delay time as needed
    },
  },
};
</script>

<style scoped>
.spacer {
  flex-grow: 1; /* Makes the spacer grow to fill available space */
  margin: 0 20px; /* Adjust the margin as needed */
}
.dateData {
  font-size: 12px;
  color: #4b4b4b;
}
</style>

<style>
.gm-ui-hover-effect {
  display: none !important;
}
.text-label {
  font-family: "Inter";
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  line-height: 24px;
}

.text-value {
  font-family: "Inter";
  font-weight: 600;
  font-style: normal;
  font-size: 14px;
}
</style>
